module.exports = __webpack_public_path__ + "img/x-square.4d2bfdf2.svg";